import { NetworkError } from 'utils/globalTypes';

const EMAIL_REGEXP = new RegExp(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
const PASSWORD_REGEXP = new RegExp(/^[\w#?!@$%^&*-]+$/);
const CODE_REGEXP = new RegExp(/^\d+$/);
const TOKEN_REGEXP = new RegExp(/^.+$/);
const SPECIAL_CHARS_AND_DIGITS_REGEXP = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\d]/;

export const errorMessage = (e?: NetworkError | string | unknown, def?: string | null): string => {
  if (!e) return '';

  let message;
  if (e && typeof e === 'object') message = e['message'];
  if (!message && e && e instanceof Error) message = e.message;
  if (!message && e && e instanceof NetworkError) message = e.message;
  if (!message && e && typeof e === 'string') message = e;
  if (!message && e && e instanceof String) message = e.valueOf();
  if (
    !message ||
    message.toLowerCase().includes('failed with') ||
    message.toLowerCase().includes('failed to')
  ) {
    message = def !== undefined ? def : message;
  }

  return message;
};

export const validateEmail = (email?: string) => {
  return !!(email && EMAIL_REGEXP.test(email));
};

export const validateName = (name?: string) => {
  if (!name) return false;
  return !SPECIAL_CHARS_AND_DIGITS_REGEXP.test(name);
};

export const validateEntityName = (name?: string) => {
  return !!name;
};

export const validateSSN = (ssn?: string) => {
  return !!ssn;
};

export const validateEIN = (ein?: string) => {
  return !!ein;
};

export const validateDate = (date?: string): boolean => {
  return !!date;
};

export const validateCountry = (country?: string) => {
  return !!country;
};

export const validateRegion = (region?: string) => {
  return !!region;
};

export const validateZipCode = (zipCode?: string) => {
  return !!zipCode;
};

export const validateCity = (city?: string) => {
  return !!city;
};

export const validateStreetAddress = (address?: string) => {
  return !!address;
};

export const validatePassword = (password?: string) => {
  return !!(password && PASSWORD_REGEXP.test(password));
};

export const validateCode = (code?: string) => {
  return !!(code && CODE_REGEXP.test(code));
};

export const validateToken = (code?: string) => {
  return !!(code && TOKEN_REGEXP.test(code));
};
